import { publicApiUrl } from 'App/utils';
import { sessionConfiguration } from 'Services/sdk-session';
import { RemindersApiClient, TaskSdkModule } from './types';

const { Configuration, RemindersApi } = require( '@emilgroup/task-sdk' ) as TaskSdkModule;

export const createRemindersApi = (): RemindersApiClient => {
  return new RemindersApi( sessionConfiguration( Configuration ) ?? new Configuration(), publicApiUrl ?? '' );
};
